// src/pages/Dashboard/Admin/SeasonStats/components/SeasonStatsEmptyState.jsx

import React from "react";

import {
  FaMagic,
  FaPlus,
} from "react-icons/fa";

export default function SeasonStatsEmptyState({
  onGenerate,
  onAdd,
  generating,
}) {
  return (
    <div className="rounded-[28px] border border-dashed border-slate-300 bg-slate-50 px-5 py-12 text-center dark:border-slate-700 dark:bg-slate-800/40">
      <div className="mx-auto h-16 w-16 rounded-full bg-gradient-to-br from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <h3 className="mt-6 text-lg font-bold text-slate-900 dark:text-white">
        Aucun historique statistique
      </h3>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-600 dark:text-slate-300">
        Générez automatiquement les statistiques de la
        saison active ou saisissez les chiffres d’une ancienne
        saison manuellement.
      </p>

      <div className="mt-5 flex flex-col justify-center gap-2 sm:flex-row">
        <button
          type="button"
          onClick={onGenerate}
          disabled={generating}
          className="inline-flex items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-emerald-700 disabled:opacity-60"
        >
          <FaMagic />
          Générer la saison active
        </button>

        <button
          type="button"
          onClick={onAdd}
          className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-4 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-[#012f6c]"
        >
          <FaPlus />
          Saisie manuelle
        </button>
      </div>
    </div>
  );
}